"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDefaultPlaceholderText_1 = __importDefault(require("./getDefaultPlaceholderText"));
const lodash_1 = require("lodash");
function getPropsForField({ field, formProps, value }) {
    return Object.assign(Object.assign({}, field), { choiceGroups: formProps.choiceGroups, disabledText: field.isDisabled ? 'No permission to edit' : undefined, isMultiline: false, metadata: formProps.metadata, placeholder: field.placeholder ||
            getDefaultPlaceholderText_1.default(field, !lodash_1.isEmpty(formProps.choiceGroups)), value });
}
exports.default = getPropsForField;
